var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.541 0.0526772C16.4637 0.0772858 12.8602 1.23744 8.53593 2.63315C4.2082 4.02533 0.608199 5.19604 0.534371 5.23471C0.383199 5.31205 0.175777 5.52651 0.0843708 5.70229C0.0456989 5.77612 0.0175739 5.92729 0.00702707 6.12065C-0.0140667 6.50737 0.0667927 6.71127 0.337496 6.95737L0.52734 7.12963L3.73711 8.2019L6.94687 9.27065L8.61328 8.11049C9.53086 7.47416 10.8457 6.5601 11.5348 6.08197L12.7863 5.21362L11.3941 7.20346C10.6277 8.29682 9.71367 9.60463 9.36211 10.1109L8.72226 11.0285L9.79453 14.2523L10.8703 17.4726L11.0426 17.6624C11.2887 17.9331 11.4926 18.014 11.8793 17.9929C12.0727 17.9824 12.2238 17.9542 12.2977 17.9156C12.4734 17.8242 12.6879 17.6167 12.7652 17.4621C12.8039 17.3882 13.9992 13.7179 15.4195 9.30932C17.8594 1.72963 18 1.27963 18 1.03705C18 0.826115 17.9824 0.748772 17.891 0.569473C17.7012 0.189787 17.3848 -5.72205e-05 16.9453 0.00345802C16.8012 0.00697327 16.6184 0.0280685 16.541 0.0526772Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/SendIcon.f17f69c2b817e9254854bd1d9fd736ad.svg";
export { ForwardRef as ReactComponent };